import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ApprovalList } from '@/components/company/approvals/approval-list';

// All supported media types for approvals (BILL = Reimbursement / Vendor Bill)
const MEDIA_TYPES = [
  'all',
  // VENDOR_BILL is the vendor half of BILL, split client-side by which
  // approval the bill clears against — it has a chip of its own.
  'VENDOR_BILL',
  'GENERAL_APPROVAL',
  'LEAVE_APPROVAL',
  'SALARY_APPROVAL',
  'TRAVEL_APPROVAL',
  'OPERATIONAL_APPROVAL',
  'QUOTATION_APPROVAL',
  'CONTRACT_APPROVAL',
  'PAYMENT_APPROVAL',
  'BILL',
  'OVERTIME_APPROVAL',
  'PUNCH_IN_APPROVAL',
  'SALE_INVOICE',
  'SALE_LEAD',
] as const;

const approvalSearchSchema = z.object({
  media_type: z.enum(MEDIA_TYPES).optional().catch('all'),
  // Which half of the screen you are in: admin sign-off, or money owed to an
  // employee. Separate from media_type so a group can show all of its types.
  group: z.enum(['admin', 'money']).optional().catch('admin'),
  // Which decision bucket is on screen. "denied" also covers the wire's
  // "rejected" bucket, which is what bills call the same thing.
  status: z.enum(['pending', 'approved', 'denied']).optional().catch('pending'),
  page: z.number().optional().catch(1),
  limit: z.number().optional().catch(20),
  search: z.string().optional(),
  startDate: z.string().optional(), // YYYY-MM-DD
  endDate: z.string().optional(), // YYYY-MM-DD
});

export const Route = createFileRoute('/(app)/company/approvals/')({
  component: ApprovalRoute,
  validateSearch: approvalSearchSchema,
});

function ApprovalRoute() {
  return <ApprovalList />;
}
